module.exports = __webpack_public_path__ + "img/play.8bc07ab0.png";